<template>
    <rkm-modal
        extra-large
        no-close-on-backdrop
        no-close-on-esc
        ref="RkmModal"
        :title="id ? 'Edição de jornada' : 'Cadastro de jornada'"
    >
        <rkm-form
            v-if="model"
            ref="RkmFormCadastro"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :disabled="!!additionals.temAgendamentos"
                        :options="form.unidades"
                        :validations="validations.unidade"
                        @change="handleUnidadeChange"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :disabled="!!additionals.temAgendamentos"
                        :options="form.infraestruturas"
                        :validations="validations.infraestrutura"
                        @change="handleInfraestruturaChange"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!!additionals.temAgendamentos"
                        :options="form.lotacoes"
                        :validations="validations.lotacao"
                        @change="handleLotacaoChange"
                        label="CBO"
                        show-default-option
                        text-field="ocupacaoDescricao"
                        v-model="model.lotacaoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6" class="especialidade-col">
                    <rkm-form-select
                        :disabled="!!additionals.temAgendamentos"
                        :options="form.especialidades"
                        :validations="validations.especialidade"
                        label="Especialidade"
                        show-default-option
                        text-field="nome"
                        v-model="model.especialidadeId"
                        value-field="id"
                    />
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor-especialidade"
                        small
                        v-rkm-popover.hover.right="{
                            html: true,
                            content: 'Se a especialidade estiver marcada como disponível no ConectaSUS Cidadão, serão exibidos campos adicionais para configurar vagas do App ConectaSUS Cidadão (consultas e retornos).'
                        }"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!!additionals.temAgendamentos"
                        :options="form.tipos"
                        :validations="validations.tipo"
                        label="Tipo de jornada"
                        show-default-option
                        text-field="nome"
                        v-model="model.tipoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.situacoes"
                        label="Situação"
                        show-default-option
                        text-field="nome"
                        v-model="model.situacaoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-date-picker
                        :disabled="!!id"
                        :end-validations="validations.periodo"
                        :range-inline="false"
                        :start-validations="validations.periodo"
                        end-label="Até"
                        range
                        start-label="Período de"
                        v-model="model.periodo"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        :disabled="!!additionals.temAgendamentos && additionals.quantidadeAgendamentos > 0"
                        :validations="validations.inicio"
                        label="Hora inicial"
                        v-model="model.inicio"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        :value="horaFinal"
                        disabled
                        label="Hora final"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-checkbox-group
                        v-if="!id"
                        :disabled="!!additionals.temAgendamentos"
                        :options="form.diasSemana"
                        :validations="validations.diasSemana"
                        button-color="outline-primary"
                        buttons
                        class="dias-semana"
                        label="Dias da semana"
                        text-field="descricao"
                        v-model="model.diasSemana"
                        value-field="id"
                    />

                    <rkm-form-select
                        v-else
                        :options="form.diasSemana"
                        disabled
                        label="Dia da semana"
                        show-default-option
                        text-field="descricao"
                        v-model="model.diaSemana"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.quantidadeConsulta"
                        :change="handleConsultasRetornosChange()"
                        label="Quantidade de consultas"
                        number
                        v-model="model.quantidadeConsulta"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!!additionals.temAgendamentos && additionals.quantidadeAgendamentos > 0"
                        :validations="validations.tempoConsulta"
                        append="Minuto(s)"
                        label="Tempo da consulta"
                        number
                        v-model="model.tempoConsulta"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.quantidadeRetorno"
                        :change="handleConsultasRetornosChange()"
                        label="Quantidade de retornos"
                        number
                        v-model="model.quantidadeRetorno"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="!!additionals.temAgendamentos && additionals.quantidadeAgendamentos > 0 && model.tempoRetorno !== null"
                        :validations="validations.tempoRetorno"
                        append="Minuto(s)"
                        label="Tempo do retorno"
                        number
                        v-model="model.tempoRetorno"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="true"
                        :value="this.totalConsultasRetornos"
                        label="Total de consultas e retornos"
                        number
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-checkbox
                        :disabled="!!additionals.temAgendamentos && additionals.quantidadeAgendamentos > 0"
                        :label="false"
                        :value="true"
                        v-model="model.permiteAgendamentoSomenteSupervisor"
                    >
                        Permitir agendamento apenas para o supervisor
                    </rkm-form-checkbox>
                </rkm-col>

            </rkm-row>

            <template v-if="isEspecialidadeConectasusCidadao">
                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-alert color="info" class="mb-2">
                            Esta especialidade está habilitada para integração com o ConectaSUS Cidadão. Apenas a quantidade informada nos campos abaixo será sincronizada no aplicativo.
                        </rkm-alert>
                    </rkm-col>
                </rkm-row>

                <rkm-row class="align-items-end">
                    <rkm-col cols="3" class="field-tooltip-col">
                        <rkm-form-input
                            :validations="validations.quantidadeConsultaConectasusCidadao"
                            label="Consultas App Cidadão"
                            number
                            v-model="model.quantidadeConsultaConectasusCidadao"
                        />
                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor-field"
                            small
                            v-rkm-popover.hover.top="{
                                html: true,
                                content: 'Quantidade de consultas desta jornada destinada ao ConectaSUS Cidadão.'
                            }"
                        />
                    </rkm-col>

                    <rkm-col cols="3" class="field-tooltip-col">
                        <rkm-form-input
                            :disabled="!model.quantidadeConsultaConectasusCidadao || model.quantidadeConsultaConectasusCidadao <= 0"
                            :validations="validations.tempoConsultaConectasusCidadao"
                            append="Minuto(s)"
                            label="Tempo consulta App Cidadão"
                            number
                            v-model="model.tempoConsultaConectasusCidadao"
                        />
                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor-field"
                            small
                            v-rkm-popover.hover.top="{
                                html: true,
                                content: 'Duração, em minutos, de cada consulta destinada ao ConectaSUS Cidadão.'
                            }"
                        />
                    </rkm-col>

                    <rkm-col cols="3" class="field-tooltip-col">
                        <rkm-form-input
                            :validations="validations.quantidadeRetornoConectasusCidadao"
                            label="Retornos App Cidadão"
                            number
                            v-model="model.quantidadeRetornoConectasusCidadao"
                        />
                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor-field"
                            small
                            v-rkm-popover.hover.top="{
                                html: true,
                                content: 'Quantidade de retornos desta jornada destinada ao ConectaSUS Cidadão.'
                            }"
                        />
                    </rkm-col>

                    <rkm-col cols="3" class="field-tooltip-col">
                        <rkm-form-input
                            :disabled="!model.quantidadeRetornoConectasusCidadao || model.quantidadeRetornoConectasusCidadao <= 0"
                            :validations="validations.tempoRetornoConectasusCidadao"
                            append="Minuto(s)"
                            label="Tempo retorno App Cidadão"
                            number
                            v-model="model.tempoRetornoConectasusCidadao"
                        />
                        <rkm-icon
                            icon="info"
                            color="secondary"
                            class="infor-field"
                            small
                            v-rkm-popover.hover.top="{
                                html: true,
                                content: 'Duração, em minutos, de cada retorno destinado ao ConectaSUS Cidadão.'
                            }"
                        />
                    </rkm-col>
                </rkm-row>
            </template>
        </rkm-form>

        <rkm-area
            v-if="form && form.equipes.length > 0"
            no-margin-top
            title="Equipes"
        >
            <rkm-table
                :fields="fields"
                :items="this.form.equipes"
                hide-filters
                hide-pagination
            />
        </rkm-area>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                :authorize="`${id ? 'update' : 'store'}-ambulatorio-jornada`"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'ine',
                    label: 'INE',
                    sortable: true
                },
                {
                    key: 'tipo',
                    label: 'Tipo',
                    sortable: true
                },
                {
                    key: 'area',
                    label: 'Área',
                    sortable: true
                },
                {
                    key: 'microarea',
                    label: 'Microárea',
                    sortable: true
                },
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true
                },
                {
                    key: 'infraestrutura',
                    label: 'Local de atendimento',
                    sortable: true
                }
            ]
        },
        isEspecialidadeConectasusCidadao() {
            if (!this.model || !this.model.especialidadeId || !this.form || !this.form.especialidades) return false

            const especialidade = this.form.especialidades.find(e => e.id === this.model.especialidadeId)

            return especialidade && especialidade.permiteIntegracaoConectasusCidadao
        },
        horaFinal() {
            const tempoConsultaEmMinutos = this.model.quantidadeConsulta * this.model.tempoConsulta
            const tempoRetornoEmMinutos = this.model.quantidadeRetorno * this.model.tempoRetorno
            const tempoConsultaCidadaoEmMinutos = (this.model.quantidadeConsultaConectasusCidadao || 0) * (this.model.tempoConsultaConectasusCidadao || 0)
            const tempoRetornoCidadaoEmMinutos = (this.model.quantidadeRetornoConectasusCidadao || 0) * (this.model.tempoRetornoConectasusCidadao || 0)

            return this.others.moment(this.model.inicio, 'HH:mm')
                .add(tempoConsultaEmMinutos + tempoRetornoEmMinutos + tempoConsultaCidadaoEmMinutos + tempoRetornoCidadaoEmMinutos, 'minutes')
                .format('HH:mm')
        },
        validations() {

            let minValue = this.model.tipoId == 1 ? { min_value: 1 } : {}
            let quantidadeAgendamentos = this.additionals.quantidadeAgendamentos >= 0 ? this.additionals.quantidadeAgendamentos : false
            let minQuantidadeConsulta = quantidadeAgendamentos > 0 ? quantidadeAgendamentos : 1

            return {
                unidade: {required: true},
                infraestrutura: {required: true},
                lotacao: {required: true},
                especialidade: {required: true},
                tipo: {required: true},
                periodo: {required: true},
                diasSemana: {required: true},
                inicio: {required: true},
                quantidadeConsulta: {
                    required: !this.model.quantidadeRetorno,
                    min_value: quantidadeAgendamentos >= 0 ? minQuantidadeConsulta : (this.quantidadeConsulta ? this.quantidadeConsulta : 1),
                },
                tempoConsulta: {
                    required: !!this.model.quantidadeConsulta,
                    ...minValue
                },
                quantidadeRetorno: {
                    required: !this.model.quantidadeConsulta,
                    min_value: Number(this.quantidadeRetorno) ? Number(this.quantidadeRetorno) : 1,
                },
                tempoRetorno: {required: !!this.model.quantidadeRetorno},
                quantidadeConsultaConectasusCidadao: {
                    min_value: 0,
                    max_value: 999,
                },
                tempoConsultaConectasusCidadao: {
                    required: this.model.quantidadeConsultaConectasusCidadao > 0,
                    min_value: 1,
                    max_value: 999,
                },
                quantidadeRetornoConectasusCidadao: {
                    min_value: 0,
                    max_value: 999,
                },
                tempoRetornoConectasusCidadao: {
                    required: this.model.quantidadeRetornoConectasusCidadao > 0,
                    min_value: 1,
                    max_value: 999,
                },
            }
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('ambulatorio.jornada'),
        }
    },
    data: () => ({
        additionals: null,
        form: null,
        id: null,
        model: null,
        others: {moment},
        quantidadeConsulta: null,
        quantidadeRetorno: null,
        totalConsultasRetornos: null,
        totalAgendamentos: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.lotacoes = []
            this.form.especialidades = []
            this.model.infraestruturaId = null
            this.model.lotacaoId = null
            this.model.especialidadeId = null

            if (value === null) return

            this.getInfraestruturas(value)
        },
        handleInfraestruturaChange(value) {
            this.form.lotacoes = []
            this.form.especialidades = []
            this.model.lotacaoId = null
            this.model.especialidadeId = null

            if (value === null) return

            this.getLotacoes(value)
        },
        handleLotacaoChange(value) {
            this.form.especialidades = []
            this.model.especialidadeId = null

            if (value === null) return

            this.getEspecialidades(value)
        },
        handleConsultasRetornosChange() {
            this.totalConsultasRetornos = Number(this.model.quantidadeConsulta || 0)
                + Number(this.model.quantidadeRetorno || 0)
                + Number(this.model.quantidadeConsultaConectasusCidadao || 0)
                + Number(this.model.quantidadeRetornoConectasusCidadao || 0)
        },
        create() {
            this.setLoading()

            this.$refs.RkmModal.show()

            const request = {
                origem: 'cadastro',
                usuarioId: this.usuarioId,
            }

            this.repositories.jornada.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.$nextTick().then(() => this.$refs.RkmFormCadastro.resetValidator())
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            this.$refs.RkmFormCadastro.validate()
                .then(valid => {
                    if (valid === false) return

                    const request = {
                        lotacaoId: this.model.lotacaoId,
                        especialidadeId: this.model.especialidadeId,
                        tipoId: this.model.tipoId,
                        situacaoId: this.model.situacaoId,
                        periodo: {
                            start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                            end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                        },
                        inicio: this.formatTime(this.model.inicio),
                        diasSemana: this.model.diasSemana,
                        quantidadeConsulta: this.model.quantidadeConsulta,
                        tempoConsulta: this.model.tempoConsulta,
                        quantidadeRetorno: this.model.quantidadeRetorno,
                        tempoRetorno: this.model.tempoRetorno,
                        quantidadeConsultaConectasusCidadao: this.model.quantidadeConsultaConectasusCidadao ?? 0,
                        tempoConsultaConectasusCidadao: this.model.tempoConsultaConectasusCidadao,
                        quantidadeRetornoConectasusCidadao: this.model.quantidadeRetornoConectasusCidadao ?? 0,
                        tempoRetornoConectasusCidadao: this.model.tempoRetornoConectasusCidadao,
                        permiteAgendamentoSomenteSupervisor: this.model.permiteAgendamentoSomenteSupervisor,
                    }

                    this.setLoading()

                    this.repositories.jornada.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            let warning = ''

                            this.resetForm()

                            if (response.data.feriados.length > 0) {
                                let message = ''

                                response.data.feriados.forEach(jornada => {
                                    message = message + `<li>
                                        Dia ${jornada.data} - ${this.form.diasSemana.find(diaSemana => diaSemana.id === jornada.diaSemana).descricao}
                                    </li>`
                                })

                                warning = warning + `
                                    Feriado(s):
                                    <ul>${message}</ul>
                                `
                            }

                            if (response.data.jornadasConflitantes.length > 0) {
                                let message = ''

                                response.data.jornadasConflitantes.forEach(jornada => {
                                    message = message + `<li>
                                        Dia ${jornada.data} - ${this.form.diasSemana.find(diaSemana => diaSemana.id === jornada.diaSemana).descricao},
                                        das ${jornada.inicio}
                                        às ${jornada.fim}
                                    </li>`
                                })

                                warning = warning + `
                                    Jornada(s) conflitante(s):
                                    <ul>${message}</ul>
                                `
                            }

                            if (warning) {
                                this.showWarningNotification(warning)
                            } else {
                                this.showSaveNotification()
                            }
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        edit(id, totalAgendamentos = null) {
            this.setLoading()

            this.id = id
            this.totalAgendamentos = totalAgendamentos

            this.$refs.RkmModal.show()

            this.repositories.jornada.edit(id)
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.model.periodo.start = this.others.moment(this.model.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    this.model.periodo.end = this.others.moment(this.model.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD')

                    this.quantidadeConsulta = this.model.quantidadeConsulta
                    this.quantidadeRetorno = this.model.quantidadeRetorno

                    this.model.quantidadeConsultaConectasusCidadao = this.model.quantidadeConsultaConectasusCidadao ?? 0
                    this.model.quantidadeRetornoConectasusCidadao = this.model.quantidadeRetornoConectasusCidadao ?? 0

                    this.handleConsultasRetornosChange()

                    this.$nextTick().then(() => this.$refs.RkmFormCadastro.resetValidator())
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        update() {
            this.$refs.RkmFormCadastro.validate()
                .then(valid => {
                    if (valid === false) return

                    const request = {
                        lotacaoId: this.model.lotacaoId,
                        especialidadeId: this.model.especialidadeId,
                        tipoId: this.model.tipoId,
                        situacaoId: this.model.situacaoId,
                        inicio: this.formatTime(this.model.inicio),
                        quantidadeConsulta: this.model.quantidadeConsulta,
                        tempoConsulta: this.model.tempoConsulta,
                        quantidadeRetorno: this.model.quantidadeRetorno,
                        tempoRetorno: this.model.tempoRetorno,
                        quantidadeConsultaConectasusCidadao: this.model.quantidadeConsultaConectasusCidadao ?? 0,
                        tempoConsultaConectasusCidadao: this.model.tempoConsultaConectasusCidadao,
                        quantidadeRetornoConectasusCidadao: this.model.quantidadeRetornoConectasusCidadao ?? 0,
                        tempoRetornoConectasusCidadao: this.model.tempoRetornoConectasusCidadao,
                        permiteAgendamentoSomenteSupervisor: this.model.permiteAgendamentoSomenteSupervisor,
                        totalAgendamentos: this.totalAgendamentos,
                    }

                    this.setLoading()

                    this.repositories.jornada.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.$refs.RkmModal.hide()
                            this.showSaveNotification()
                            this.$emit('updated', response.data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        save() {
            if (this.id) {
                this.update()
            } else {
                this.store()
            }
        },
        resetForm() {
            this.form.diasSemana.forEach(diaSemana => diaSemana.disabled = true)

            this.model.situacaoId = null

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.inicio = null
            this.model.fim = null
            this.model.diasSemana = []
            this.model.quantidadeConsulta = null
            this.model.tempoConsulta = null
            this.model.quantidadeRetorno = null
            this.model.tempoRetorno = null
            this.model.quantidadeConsultaConectasusCidadao = 0
            this.model.tempoConsultaConectasusCidadao = null
            this.model.quantidadeRetornoConectasusCidadao = 0
            this.model.tempoRetornoConectasusCidadao = null

            this.$nextTick().then(() => this.$refs.RkmFormCadastro.resetValidator())
        },
        setDaysOfWeek(startDate, endDate) {
            this.model.diasSemana = []
            this.form.diasSemana.forEach(diaSemana => diaSemana.disabled = true)

            startDate = this.others.moment(startDate)
            endDate = this.others.moment(endDate)

            if (startDate.isSame(endDate)) {
                this.model.diasSemana.push(startDate.day() + 1)
            }

            while (startDate.isSameOrBefore(endDate)) {
                this.form.diasSemana.find(diaSemana => diaSemana.id == startDate.day() + 1).disabled = false
                startDate.add(1, 'days')
            }
        },
        async getInfraestruturas(unidadeId) {
            const request = {
                origem: 'cadastro',
                listar: 'infraestruturas',
                usuarioId: this.usuarioId,
                unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.infraestruturas = response.data

                if (this.form.infraestruturas.length === 1) {
                    const selected = this.form.infraestruturas[0]
                    this.model.infraestruturaId = selected.id

                    this.getLotacoes(this.model.infraestruturaId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getLotacoes(infraestruturaId) {
            const request = {
                origem: 'cadastro',
                listar: 'lotacoes',
                usuarioId: this.usuarioId,
                infraestruturaId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.lotacoes = response.data

                if (this.form.lotacoes.length === 1) {
                    const selected = this.form.lotacoes[0]
                    this.model.lotacaoId = selected.id

                    this.getEspecialidades(this.model.lotacaoId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getEspecialidades(lotacaoId) {
            const request = {
                origem: 'cadastro',
                listar: 'especialidades',
                usuarioId: this.usuarioId,
                lotacaoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.jornada.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.especialidades = response.data

                if (this.form.especialidades.length === 1) {
                    const selected = this.form.especialidades[0]
                    this.model.especialidadeId = selected.id
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
    },
    mixins: [error, formats, repository, stringCase],
    props: {
        usuarioId: {type: [Number, String], required: true},
    },
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                if (value.start && value.end) {
                    this.setDaysOfWeek(value.start, value.end)
                }
            },
        },
        'model.quantidadeConsulta'() {
            this.handleConsultasRetornosChange()
        },
        'model.quantidadeRetorno'() {
            this.handleConsultasRetornosChange()
        },
        'model.quantidadeConsultaConectasusCidadao'(value) {
            if (!value || value <= 0) {
                this.model.tempoConsultaConectasusCidadao = null
            }
            this.handleConsultasRetornosChange()
        },
        'model.quantidadeRetornoConectasusCidadao'(value) {
            if (!value || value <= 0) {
                this.model.tempoRetornoConectasusCidadao = null
            }
            this.handleConsultasRetornosChange()
        },
    },
}
</script>

<style scoped>
.dias-semana >>> .btn-group {
    width: 100%;
}

.especialidade-col {
    position: relative;
}

.infor-especialidade {
    color: #acacac;
    height: 15px;
    width: 15px !important;
    border-radius: 31px;
    padding: 3px;
    border: 1px solid #c2c2c2;
    position: absolute;
    top: 5px;
    left: 115px;
}

.field-tooltip-col {
    position: relative;
}

.infor-field {
    color: #acacac;
    height: 15px;
    width: 15px !important;
    border-radius: 31px;
    padding: 3px;
    border: 1px solid #c2c2c2;
    position: absolute;
    top: 5px;
    right: 20px;
}
</style>
